<template>
    <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
        <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
            <div class="" v-bind:style="ContainerPadding">
                <div :class="BlockProps.ShowBackgroundImage? 'block-background' : ''" :style="BackgroundStyle">
                    <div class="text-center mx-lg-auto shadow-lg pt-9 pb-9">
                        <span v-if="BlockProps.ShowBackgroundImage" :style="{'background': BlockProps.BackgroundOverlay + ' !important'}" class="bg-overlay"></span>
                        <h1 class="display-4">
                            <omnieditor :iseditmode="iseditmode" editortype="icon" v-if="BlockProps.Icon.Show" :blockprops="BlockProps" :inline="true" v-model:icon="BlockProps.Icon" :prompt="'Icon (click to change)'"></omnieditor>
                            &nbsp;<omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Header" tag-name="span" :init="EditorConfig" />
                        </h1>
                        <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Subtext" class="lead" tag-name="span" :init="EditorConfig" />

                    </div>
                </div>
            </div>

            <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div class="modal-dialog modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                        </div>
                        <div class="modal-body">
                            <hr style="margin: 0px; margin-bottom:10px;" />
                            <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                            <propertytogglededitor propertyname="Show" :blockprops="BlockProps.Icon" prompt="Show Icon"></propertytogglededitor>
                            <propertytogglededitor propertyname="ShowBackgroundImage" :blockprops="BlockProps" prompt="Background Image Instead Of Color"></propertytogglededitor>

                            <small style="font-size:12px;"><i class="bi bi-info-circle"></i>  Background Image (100kb max, each)</small>
                            <hr style="margin: 0px; margin-bottom:10px;" />
                            <div class="row">
                                <div class="col col-12 text">
                                    <div style="display:inline-block; width: 100px !important;height: 75px !important;">
                                        <img style="object-fit:cover; width:100% !important; height:100% !important;object-position:center  !important;box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; border: 1px solid black" :src="BlockProps.Img1" alt="Image1" />
                                    </div>
                                    <i class="bi bi-chevron-double-right"></i>
                                    <button @click="UploadNewSlideBackground(1)" type="button" style="margin-left:5px;" class="btn btn-sm btn-primary"><i class="bi bi-image"></i> Change Image</button>
                                </div>
                                <hr style="margin-top: 5px; margin-bottom:5px;" />
                            </div>


                            <propertycoloreditor :propertyname="'BackgroundOverlay'" :blockprops="BlockProps" :prompt="'Background Image Overlay'"></propertycoloreditor>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                            <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'


    export default {
        inheritAttrs: false,
        name: 'SimpleIconHero',
        mixins: [ContentBlockBase],
        props: [],
        components: {
        },
        computed:
        {
            BackgroundStyle() {
                if (!this.BlockProps.ShowBackgroundImage) {
                    return { 'background-color': this.BlockProps.BGColor + ' !important' };
                }

                return {
                    'background-image': 'url(' + this.BlockProps.Img1 + ')',
                };
                 
            },
            RenderDirection() {
                if (!this.BlockProps.Flipped) {
                    return { "flex-direction": "column" };
                } else {
                    return { "flex-direction": "column-reverse" };
                }
            }
        },
        data() {          
        },
        watch: {
        },
        methods:
        {           
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            OnSlideImageUploaded: function (args) {
                if (args.success) {
                    if (this.BlockProps[args.idx] && args.url) {
                        this.BlockProps[args.idx] = args.url;
                    }
                }

                this.EditProperties();
            },
            UploadNewSlideBackground: function (idx) {
                this.HideEditProperties();
                var args = {};

                var imgProp = 'Img' + idx;
                args.ExistingFileURL = this.BlockProps[imgProp];
                args.CompleteCallback = "OnSlideImageUploaded-" + this.BlockProps.UId;
                args.CompleteCallbackData = { MaxSize: 1024 * 100, idx: imgProp, url: '' }; // this will be sent back in the callback
                args.Prompt = `Image`;
                EventHub.$emit('UploadNewAssetBlockConfig', args);
            }
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            EventHub.$on('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        beforeUnmount()
        {
            EventHub.$off('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        mounted() {
            nextTick().then(() => {
      
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    

    .block-background {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        position: relative;
        z-index: 1;
    }

    .bg-overlay {
        content: "";
        display: block;
        position: absolute;
        z-index: -1;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 1);
    }

    .block-background::before {
      
    }
</style>

